module.exports = __webpack_public_path__ + "img/favicon.eeb946d0.svg";